module.exports = __webpack_public_path__ + "img/eos.66a7d25e.png";